export default "__VITE_ASSET__a02cfb4e__"